import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useReducer, useEffect } from 'react';
import { GoogleReCaptchaProvider } from '../../Modules/IVRecaptcha';
import GlobalConfig from '../../lib/GlobalConfig';
import { AnalyticsUtils } from '../../utils/analytics/AnalyticsUtils';
import sharedStateReducer, { addUser } from './SharedReducer';
import { FeatureConfigProvider } from '../FeatureConfig';
const initialSharedState = {
    config: {
        RECAPTCHA_KEY: '',
        API: {
            AUTH_API: '',
            CORE_API: '',
            ANALYTICS_API: '',
            MEDIA_API: '',
        },
        APP_ENV: '',
        CDN_URL: {
            SHARED_URL: '',
            EDITOR_URL: '',
            LIHP_URL: '',
        },
        HOST_URL: '',
        STUDIO_URL: '',
        AI_URL: '',
        CREATE_PAGE_HOST_URL: '',
    },
    user: null,
    siteConfig: null,
};
export const SharedContext = createContext({
    state: initialSharedState,
    dispatch: () => { },
});
function SharedProvider(props) {
    const { children, config, user, featureConfig } = props;
    const { API, APP_ENV, CDN_URL, HOST_URL, CREATE_PAGE_HOST_URL, IMAGE_KIT, siteConfig, ...otherConfig } = config;
    const [sharedState, sharedDispatch] = useReducer(sharedStateReducer, {
        ...initialSharedState,
        config: {
            ...otherConfig,
        },
        siteConfig,
        user: user || null,
    });
    GlobalConfig.api = API;
    GlobalConfig.cdn = CDN_URL;
    GlobalConfig.appENV = APP_ENV;
    GlobalConfig.HOST_URL = HOST_URL;
    if (CREATE_PAGE_HOST_URL) {
        GlobalConfig.CREATE_PAGE_HOST_URL = CREATE_PAGE_HOST_URL;
    }
    if (siteConfig) {
        GlobalConfig.SiteConfig = siteConfig;
    }
    if (IMAGE_KIT) {
        GlobalConfig.imageKit = IMAGE_KIT;
    }
    useEffect(() => {
        GlobalConfig.SiteConfig = siteConfig;
    }, [siteConfig]);
    const value = { state: sharedState, dispatch: sharedDispatch };
    useEffect(() => {
        sharedDispatch(addUser(user));
        AnalyticsUtils.userData = user;
    }, [user]);
    return (_jsx(SharedContext.Provider, { value: value, children: _jsx(FeatureConfigProvider, { featureConfig: featureConfig, children: _jsx(GoogleReCaptchaProvider, { reCaptchaKey: sharedState.config.RECAPTCHA_KEY, loadOnDemand: true, scriptProps: {
                    defer: true,
                    appendTo: 'body',
                }, children: children }) }) }));
}
export default SharedProvider;
